import { toast } from "react-toastify";

import obtenerConcesiones from "../concesiones/obtener";
import obtenerDirecciones from "../direccion/obtener";
import agruparArray from "../../historial/agruparArray";
import obtenerHistorialPorConcesion from "../historial/obtenerPorConcesion";
import obtenerHistorialSinConcesion from "../historial/obtenerSinConcesion";
import expediente from "../../xml/obtenerExpedientePorAutorizacion";

export default async function obtenerPorIdConcesion(data, setData) {

    let dataHistorial;
    const endpoint = `/api/contribuyente/obtenerPorConcesion/${data?.concesionActual?.idConcesion ?? ""}`;
    const id = toast.loading("Cargando...");
    try {
        const { data: contribuyente } = await (await fetch(endpoint)).json();
        const concesiones = await obtenerConcesiones(await contribuyente.idContribuyente);
        const direcciones = await obtenerDirecciones(await contribuyente.idContribuyente);
        const indexConcesion = buscarIndexConcesiones(data?.concesionActual?.idConcesion, concesiones);
        const finalConcesionActual = concesiones[indexConcesion];

        const idAutorizacion = data?.concesionActual?.idConcesion;

        if (idAutorizacion) {
            const dataWS = await expediente(idAutorizacion);
            finalConcesionActual.numeroExpediente = await dataWS?.NoExpedienteActual ?? "";
        }

        if (concesiones[indexConcesion] !== undefined) dataHistorial = await obtenerHistorialPorConcesion(await concesiones[indexConcesion].idConcesion);
        else dataHistorial = await obtenerHistorialSinConcesion(await contribuyente.idContribuyente);

        const dataObject = {
            contribuyente: contribuyente, concesiones: [...concesiones], direcciones: [...direcciones],
            concesionActual: { ...concesiones[indexConcesion] }, historial: [...dataHistorial],
            historialArray: [...agruparArray(dataHistorial, 10)]
        }

        setData(dataObject);
        toast.update(id, { render: "Hecho!", type: "success", isLoading: false, autoClose: 500, draggable: true });

    }
    catch (error) {
        console.log(error);
        toast.update(id, { render: "Error!", type: "warning", isLoading: false, autoClose: 500, draggable: true });
    }
}

/**
 * BUSCA ÍNDICE DE CIERTA CONCESIÓN
 * @param {Number} idConcesion 
 * @param {Int32Array} concesionesArray 
 * @returns ÍNDICE QUE ESPECIFICA LA POSICIÓN DE LA CONCESIÓN BUSCADA
 */
export function buscarIndexConcesiones(idConcesion, concesionesArray) {
    let index = 0;
    for (let i = 0; i < concesionesArray.length; i++) {
        if (concesionesArray[i].idConcesion === Number(idConcesion)) {
            index = i;
            break;
        }
    }
    return index;
}
